import CollapsibleCard from "@entities/AIControls/ui/CollapsibleCard";
import { useUpdateBriefAiSettings } from "@entities/brief/lib/hooks/ai/useUpdateBriefAiSettings";
import AutomatedContentReview from "@features/AIControls/ui/AutomatedContentReview";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { Typography } from "@shared/ui";
import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { AiFitCheckPromptPanel } from "./AiFitCheckPromptPanel";
import styles from "./styles.module.scss";

export function CampaignAiSettingsPanel() {
  const { brief, briefId } = useBriefStore();
  const { updateBriefAiSettings, isUpdating } = useUpdateBriefAiSettings();
  const [isToggleOn, setIsToggleOn] = useState(
    !!brief?.isCreatorFitCheckEnabled
  );

  const isOverviewIncomplete = !brief?.form?.isOverviewCompleted;
  const isCreatorFitCheckEnabled = !!brief?.isCreatorFitCheckEnabled;

  useEffect(() => {
    setIsToggleOn(!!brief?.isCreatorFitCheckEnabled);
  }, [brief?.isCreatorFitCheckEnabled, briefId]);

  const handleToggle = (checked: boolean) => {
    if (!briefId || !brief?.brandId) return;

    if (!checked) {
      if (isCreatorFitCheckEnabled) {
        updateBriefAiSettings({
          briefId,
          brandId: brief.brandId,
          isCreatorFitCheckEnabled: false,
        });
      }
      setIsToggleOn(false);
      return;
    }

    setIsToggleOn(true);
  };

  return (
    <div className={styles.settingsPage}>
      <div style={{ maxWidth: "42rem" }}>
        <CollapsibleCard          
          collapseProps={{
            items: [
              {
                key: "campaign-ai-settings",
                label: (
                  <div>
                    <div className={styles.headerContent}>
                      <div className={styles.iconWrapper}>
                        <Sparkles size={24} />
                      </div>
                      <div>
                        <Typography.Title level={2} className={styles.title}>
                          AI Settings
                        </Typography.Title>
                        <Typography.Text className={styles.description}>
                          Configure AI Fit Check to score creator fit from a master
                          prompt.
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                ),
                children: (
                  <div className={styles.settingsPanel}>
                    <AiFitCheckPromptPanel
                      isCreatorFitCheckEnabled={isCreatorFitCheckEnabled}
                    />
                  </div>
                ),
              },
            ],
            collapsible: "icon",
            activeKey: isToggleOn ? ["campaign-ai-settings"] : [],
            onChange: (key) => {
              const checked = key?.[0] === "campaign-ai-settings";
              handleToggle(checked);
            },
          }}
          switchProps={{
            loading: isUpdating,
          }}
        />
      </div>
      <div style={{ maxWidth: "42rem" }}>
        <AutomatedContentReview isDisabled={false} />
      </div>
    </div>
  );
}

